import type { Suggestion } from "./types";

// Outcome telemetry is the audit trail for advice that caused an action, not a
// second impression stream. Keep the sentence bounded even if a future provider
// ignores its word limit; this payload is stored with the event row.
const MAX_ADVICE_TEXT = 700;

/** The exact rendered advice plus stable, non-personal labels for later review. */
export function adviceSnapshot(s: Suggestion): Record<string, unknown> | null {
  const text = typeof s.reasoning === "string" ? s.reasoning.trim() : "";
  if (!text) return null;

  return {
    text: text.slice(0, MAX_ADVICE_TEXT),
    prompt_version: s.advice_meta?.prompt_version ?? "unknown",
    copy_variant: s.advice_meta?.copy_variant ?? "unknown",
    structure: {
      reason_type: s.reason?.type ?? "unknown",
      market: s.market ?? "unknown",
      line_basis: s.line_basis ?? "unknown",
      momentum_read: s.momentum_read ?? "none",
      facts_oppose: s.facts_oppose === true,
      tier: s.tier ?? "none",
      is_live: s.is_live !== false,
      type: s.type ?? "single",
    },
  };
}
